import addresses from "../contracts/index"
import NFT from '../contracts/ABIs/Marketplace.json'
import {ethers} from 'ethers'
import Web3Modal from 'web3modal'
import ERROR from '../utils/error'

const createContractCalls = () => {

const loadProvider = async () => {
    try {
        const web3Modal = new Web3Modal();
        const connection = await web3Modal.connect();
        const provider = new ethers.providers.Web3Provider(connection);
        return provider.getSigner();
    }
    catch (e) {
        console.log("loadProvider: ", e)
        
    }
  }

const mint = async (data , library , chainId) => {
    try {
    console.log("data" , data)  
    let signer = await loadProvider()
    let price = PRICE_PER_NFT(library,chainId)
    const contract = new ethers.Contract(addresses[chainId].marketplace, NFT , signer)
    let _mint = await contract.mint({value:price})
    let tx = await _mint.wait()
    ERROR.log_message("Successfully minted")
    return true 
    } catch (error) {
    console.log(error)
    console.log(error.error.code == -32603)
    if(error.error.code == -32603)
     ERROR.catch_error({message:"Max tokens minted"}, 'mint')   //"REQUEST REJECTED"
    else
    ERROR.catch_error({message:"REQUEST REJECTED"}, 'mint')   //"REQUEST REJECTED"
     return false 
    }
}

const PRICE_PER_NFT = async (library , chainId) => {
    try {
    let signer = await loadProvider()
    const contract = new ethers.Contract(addresses[chainId].marketplace, NFT , signer)
    let _PRICE_PER_NFT = await contract.PRICE_PER_NFT()
    // let tokenURI = await contract.tokenURI(1)
    // console.log("URI",tokenURI);
    return _PRICE_PER_NFT.toString()
    } catch (error) {
        console.log("PRICE_PER_NFT" , error)   
    }
}
const totalSupply = async (library , chainId) => {
    try {
    let signer = await loadProvider()
    const contract = new ethers.Contract(addresses[chainId].marketplace, NFT , signer)
    let _totalSupply = await contract.MAX_SUPPLY()
    return _totalSupply.toString()
    } catch (error) {
        console.log("totalSupply" , error)   
    }
}
const tokenIds = async (library , chainId) => {
    try {
    let signer = await loadProvider()
    const contract = new ethers.Contract(addresses[chainId].marketplace, NFT , signer)
    let _tokenIds = await contract._tokenIds()
    return _tokenIds.toString()
    } catch (error) {
        console.log("_tokenIds" , error)   
    }
}



return {
    mint,
    tokenIds,
    totalSupply,
    PRICE_PER_NFT,
}

}
const calls = createContractCalls();


export default calls;